import type { ErrorEvent, Breadcrumb } from '@sentry/vue'

const TRACKING_HOSTS = [
  'attn.tv',
  'blackcrow.ai',
  'facebook.net',
  'fueled.io',
  'google.com',
  'hotjar.com',
  'icanhazip.com',
  'ipify.org',
  'klavyio.com',
  'redditstatic.com',
  'sentry.io',
  'shopifysvc.com',
  'tiktok.com'
]

const TRACKING_PATHS = [
  '/cdn/shopifycloud'
]

const getTLD = (host: string) => host.split('.').reverse().splice(0,2).reverse().join('.')

const log = (...rest: unknown[]) => {
  if (import.meta.env.DEV) {
    console.log(...rest)
  }
}

// https://gist.github.com/jeengbe/b10fa78d9303051a3ce55620402aa082

export const isProbablyBlockedByAdblockNetworkError = (error: ErrorEvent): boolean => {
  const now = Date.now()

  if (!error.breadcrumbs) {
    return false
  }

  // We go from the back since the last breadcrumb is most likely the erroneous one
  for (let i = error.breadcrumbs.length - 1; i >= 0; i--) {
    const breadcrumb = error.breadcrumbs[i]

    if (!breadcrumb) {
      continue
    }

    // We only need to check the last 5s of breadcrumbs as any earlier breadcrumbs are definitely unrelated
    if (breadcrumb.timestamp && now - breadcrumb.timestamp * 1000 > 5000) {
      break
    }

    if (isProbablyBlockedByAdblockBreadcrumb(breadcrumb)) {
      return true
    }
  }

  return false
}

const isProbablyBlockedByAdblockBreadcrumb = (breadcrumb: Breadcrumb): boolean => {
  const { level, category, data } = breadcrumb
  log('[Sentry] level:', level, 'category', category)
  if (level !== 'error' || (category !== 'xhr' && category !== 'fetch')) {
    return false
  }

  const url = data?.url as string | undefined
  log('[Sentry] url:', url)
  if (!url) {
    return false
  }

  return isProbablyBlockedByAdblockUrl(url)
}

const isProbablyBlockedByAdblockUrl = (urlString: string) => {
  const url = new URL(urlString)
  const tld = getTLD(url.host)
  log('[Sentry] tld:', tld, 'path:', url.pathname)
  return TRACKING_HOSTS.includes(tld) || TRACKING_PATHS.some(i => url.pathname.startsWith(i))
}
